module.exports = __webpack_public_path__ + "static/media/Timer 1.f652230d.png";